module.exports = __webpack_public_path__ + "img/excelLogo.3c183466.png";